import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProcesosService {

  constructor(private readonly http: HttpClient) { }

  crearProceso(data: any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/crearProceso`, body, { headers });
  }
  
  listarProcesosFiltros(limit: any, offset: any, procNombre?: any, procTipo?: any, procPeriodo?: any, estProcesoId?: any): Observable<any[]> {
    const data = {
      limit,
      offset,
      procNombre: procNombre ? procNombre : null,
      procTipo: procTipo ? procTipo : null,
      procPeriodo: procPeriodo ? procPeriodo : null,
      estProcesoId: estProcesoId ? estProcesoId : null
    };
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/listarProcesosFiltros`, body, { headers });
  }

  obtenerProcesoById(procId: any, procTipo: any): Observable<any[]> {
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/obtenerProcesoById/${procId}/${procTipo}`);
  }

  actualizarEstadoProceso(procId: any, estProcesoId: any): Observable<any[]> {
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/actualizarEstadoProceso/${procId}/${estProcesoId}`);
  }

  buscarPeriodoExistente(procPeriodo: any): Observable<any[]> {
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/buscarPeriodoExistente/${procPeriodo}`);
  }

  cerrarProceso(data: any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/cerrarProceso`, body, { headers });
  }

  reabrirProceso(data: any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/procesos/reabrirProceso`, body, { headers });
  }
}
